import { render, staticRenderFns } from "./about-introduction.vue?vue&type=template&id=3bd9916a&scoped=true&"
import script from "./about-introduction.vue?vue&type=script&lang=js&"
export * from "./about-introduction.vue?vue&type=script&lang=js&"
import style0 from "./about-introduction.vue?vue&type=style&index=0&id=3bd9916a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd9916a",
  null
  
)

export default component.exports